module.exports = __webpack_public_path__ + "static/media/headerLogo.d16580e4.png";